import React from 'react';
import { Radio, Space } from 'antd';
import { css } from '@emotion/react';
import { SessionForm } from '@components/Clinicians/session-form';
import { SessionFormItem } from './SessionFormItem';

const ClinicalRadioButtons = ({
  field,
  label = '',
  items,
  direction = 'vertical',
  disabled,
  required = false,
  onChange
}: {
  field: keyof SessionForm;
  label?: string;
  items: string[];
  direction?: 'vertical' | 'horizontal';
  disabled: boolean;
  required?: boolean;
  onChange: ({ field, value }: { field: keyof SessionForm; value: string }) => void;
}) => {
  return (
    <SessionFormItem
      key={`${field}-form-item`}
      name={field}
      label={<span>{label}</span>}
      required={!!label && required}
      isGroupField
    >
      <Radio.Group disabled={disabled} onChange={({ target }) => onChange({ field, value: target.value })}>
        <Space
          direction={direction}
          css={css`
            margin: 8px 0;
          `}
        >
          {items.map((item) => (
            <Radio key={item} value={item}>
              {item}
            </Radio>
          ))}
        </Space>
      </Radio.Group>
    </SessionFormItem>
  );
};

export default ClinicalRadioButtons;
